import React from "react";
import ModalContainer from "../../common/modals/modalContainer/ModalContainer";
import { Button } from "@mui/material";
import { useDownloadAdtQuery } from "app/store/adt/api/adtApi";
import Loading from "components/common/loading/Loading";

const ViewAdtModal = (props) => {
  const { show, dataRow, close } = props;
  const { data, isError, error, isFetching } = useDownloadAdtQuery(
    dataRow.adt_file
  );

  const handleClose = () => {
    close();
  };

  const renderContent = () => {
    if (isFetching) {
      return <Loading />;
    }
    if (isError) {
      return (
        <div
          style={{
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {error?.message}
        </div>
      );
    }
    if (data) {
      return (
        <pre style={{ whiteSpace: "pre-line" }}>
          {typeof data === "string" ? data : ""}
        </pre>
      );
    }
    return null;
  };

  return (
    <>
      <ModalContainer title={`ADT`} show={show}>
        <div
          style={{
            width: "500px",
            overflowWrap: "break-word",
          }}
        >
          {renderContent()}
        </div>

        <div style={{ display: "flex", justifyContent: "end" }}>
          <Button
            variant="contained"
            color="primary"
            style={{ margin: "1%" }}
            onClick={() => handleClose()}
          >
            Close
          </Button>
        </div>
      </ModalContainer>
    </>
  );
};

export default ViewAdtModal;
